import { createInertiaApp } from "@inertiajs/react";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { init as initPlausible } from "@plausible-analytics/tracker";
import { kizTheme } from "../components/ui/theme";
import "./application.css";

initPlausible({ domain: "kizatx.com" });

type ResolvedComponent = {
  default: React.ComponentType<any>;
};

const el = document.getElementById("app");

if (!el) throw new Error("Root element #app not found");
if (!el.dataset.page) throw new Error("Missing data-page attribute");

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<ResolvedComponent>("../pages/**/*.tsx", {
      eager: false,
    });
    const key = `../pages/${name}.tsx`;
    if (!pages[key]) throw new Error(`Missing Inertia page: '${name}.tsx'`);
    return pages[key]();
  },

  setup({ App, props }) {
    createRoot(el).render(
      createElement(
        MantineProvider,
        { theme: kizTheme, forceColorScheme: "dark" },
        createElement(Notifications, { position: "top-right" }),
        createElement(App, props)
      )
    );
  },
});
